import * as config from "./config/config.js"
import * as helper from "./util/helper.js"
import * as faIcon from "./components/faIcon.js"
import * as general from "../../siteManagement/general.js"
import * as httpManager from "./util/httpManager.js"
import * as notificationHelper from "./util/notificationHelper.js"
import * as appLauncher from "../../siteManagement/appLauncher.js"
import * as appHelper from "../appHelper.js"
import * as grid from "./components/grid.js"
import * as StatisticReports from "../dashboard/report/statistic_reports.js"
import * as StatisticsUsers from "../dashboard/ticket/statistics_user.js"
import * as StatisticFavoriteProject from "../dashboard/favorite/statistic_favorite_project.js"
import * as StatisticFavoriteTicket from "../dashboard/favorite/statistic_favorite_ticket.js"
import * as StatisticFavoriteAssignment from "../dashboard/favorite/statistic_favorite_assignment.js"
import * as StatisticFavoriteMachine from "../dashboard/favorite/statistic_favorite_machine.js"
import * as StatisticFavoriteAddress from "../dashboard/favorite/statistic_favorite_address.js"
import * as WorkList from "../resourcePlanningScheduler/workList.js"
import * as CommonApp from "../core/components/commonApp.js"
import * as DashboardStatistics from "../dashboard/ticket/statistics.js"
import * as DialogHelper from "../core/util/dialogHelper.js";
import * as IsSearchField from "../core/components/isSearchField.js"
import * as StatisticReportsUser from "../dashboard/report/statistic_reports_user"
import * as  Sheet from "../../siteManagement/sheet.js"
import * as Toolbar from "./components/toolBar.js"
import * as DropDownList from "./components/dropDownList.js"
import * as DatePicker from "./components/datePicker.js"
import * as TextBox from "./components/textBox.js"
import * as Button from "./components/button.js"
import * as FaIcon from "./components/faIcon.js"
import * as IngridHelper from "./util/ingridHelper.js"
import * as EditableGrid from "./components/editableGrid/editableGrid.js"
import * as Field from "./components/field.js"
import * as Dialog from "./components/dialog.js"
import * as IsNumericTextBox from "./components/isNumericTextBox.js"
import * as IsPanelBarDetails from "./components/isPanelbarDetails.js"
import * as componentHelper from "./util/componentHelper.js"
import * as FullHeightContainer from "./components/FullHeighContainer.js"
import * as React from "react"
import * as ReactDOM from "react-dom"
import * as ErrorApp from "../error/error.js"
import * as FormGenerator from "./components/formGenerator.js"
import * as CheckBox from "./components/checkBox.js"
import * as RightDrawerContainer from "./components/rightDrawerContainer.js"
import * as EventManager from "../../siteManagement/eventManager.js";

interface RequiredJob {
    requiredDependencies: string[],
    callback
}

function getFsmModule(module: string): any {
    const lowerCaseModule = module?.toLowerCase();

    if (lowerCaseModule.endsWith("react"))
        return React;

    if (lowerCaseModule.endsWith("react-dom"))
        return ReactDOM;

    switch (lowerCaseModule) {
        case "/app/core/components/editablegrid/editablegrid":
            return EditableGrid;
        case "/app/core/util/ingridhelper":
            return IngridHelper;
        case "/app/core/components/faicon":
            return FaIcon;
        case "/app/core/components/button":
            return Button;
        case "/app/core/components/textbox":
            return TextBox;
        case "/app/core/components/datepicker":
            return DatePicker;
        case "/app/core/components/dropdownlist":
            return DropDownList;
        case "/app/core/components/toolbar":
            return Toolbar;
        case "/sitemanagement/sheet":
            return Sheet;
        case "/app/dashboard/report/statistic_reports_user":
            return StatisticReportsUser;
        case "/app/core/components/issearchfield":
            return IsSearchField;
        case "/app/core/util/dialoghelper":
            return DialogHelper;
        case "/app/dashboard/ticket/statistics":
            return DashboardStatistics;
        case "/app/core/components/grid":
            return grid;
        case "/app/apphelper":
            return appHelper;
        case "/app/core/config/config":
            return config;
        case "/app/core/util/helper":
            return helper;
        case "/app/core/components/faicon":
            return faIcon;
        case "/sitemanagement/general":
            return general;
        case "/app/core/util/httpmanager":
            return httpManager;
        case "/app/core/util/notificationhelper":
            return notificationHelper;
        case "/sitemanagement/applauncher":
            return appLauncher;
        case "/app/dashboard/report/statistic_reports":
            return StatisticReports;
        case "/app/dashboard/ticket/statistics_user":
            return StatisticsUsers;
        case "/app/dashboard/favorite/statistic_favorite_project":
            return StatisticFavoriteProject;
        case "/app/dashboard/favorite/statistic_favorite_ticket":
            return StatisticFavoriteTicket;
        case "/app/dashboard/favorite/statistic_favorite_assignment":
            return StatisticFavoriteAssignment;
        case "/app/dashboard/favorite/statistic_favorite_machine":
            return StatisticFavoriteMachine;
        case "/app/dashboard/favorite/statistic_favorite_address":
            return StatisticFavoriteAddress;
        case "/app/resourceplanningscheduler/worklist":
            return WorkList;
        case "/app/core/components/commonapp":
            return CommonApp;
        case "/app/core/components/isnumerictextbox":
            return IsNumericTextBox;
        case "/app/core/components/field":
            return Field;
        case "/app/core/components/dialog":
            return Dialog;
        case "/app/core/components/fullheightcontainer":
            return FullHeightContainer;
        case "/app/core/util/componenthelper":
            return componentHelper;
        case "/app/core/components/ispanelbardetails":
            return IsPanelBarDetails;
        case "/app/error/error":
            return ErrorApp;
        case "/app/core/components/formgenerator":
            return FormGenerator;
        case "/app/core/components/checkbox":
            return CheckBox;
        case "/app/core/components/rightdrawercontainer":
            return RightDrawerContainer;
        case "/sitemanagement/eventmanager":
            return EventManager;
        default:
            return null;
    }
}

class RequireProcessor {
    private queue: RequiredJob[];
    private isProcessing;
    constructor() {
        this.queue = []; // Warteschlange f�r Aufrufe
        this.isProcessing = false; // Status ob gerade verarbeitet wird
    }

    public require = (basePath: string, requiredDependencies, callback): void => {
        // Erstelle einen Job mit zus�tzlichen Informationen
        const job: RequiredJob = {
            requiredDependencies,
            callback
        };

        this.queue.push(job);

        if (!this.isProcessing) {
            this.isProcessing = true;
            this.processQueue(basePath).finally(() => {
                this.isProcessing = false;
            });
        }
    }

    processQueue = async (basePath: string) => {
        while (this.queue.length > 0) {
            const job = this.queue.shift();

            try {
                const resolvedDependencies = await this.resolveDependencies(basePath, job.requiredDependencies, null);
                job.callback(...resolvedDependencies);
            } catch (error) {
                console.error('Unerwarteter Fehler:', error);
            }
        }
    }

    private getAbsolutePathToDependency = (basePath: string, dependency: string) => {
        if (dependency == "exports" || dependency == "require") {
            return dependency;
        }
        const url = new URL(dependency, "http://" + basePath);
        return url.pathname;
    }

    private async resolveDependencies(basePath: string, requiredDependencies: string[], exportOrRquireModuleResolver): Promise<any[]> {
        const resolvedDependencies = [];
        for (const dependency of requiredDependencies) {
            try {
                if (dependency == "") {
                    resolvedDependencies.push({});
                }
                else {
                    const dependencyAbsolutePath = this.getAbsolutePathToDependency("react_app" + basePath + "/", dependency);
                    const resolvedDependency = await this.resolveDependency(dependencyAbsolutePath, exportOrRquireModuleResolver);
                    resolvedDependencies.push(resolvedDependency);
                }
            } catch (error) {
                console.error(`Fehler beim Import von ${dependency}:`, error);
            }
        }
        return resolvedDependencies;
    }

    private getDependencyPathFromName = (dependency: string) => {
        return dependency.substring(0, dependency.lastIndexOf("/"));
    }

    private dependencyCache = new Map<string, any>();
    private resolveDependency = async (dependency: string, exportOrRquireModuleResolver) => {
        if (this.dependencyCache.has(dependency)) {
            console.log("Has dep in cache: "+ dependency)
            return this.dependencyCache.get(dependency);
        }

        const fsmModule = getFsmModule(dependency);
        if (fsmModule != null) {
            return fsmModule;
        }
        const exportOrRequire = exportOrRquireModuleResolver ? exportOrRquireModuleResolver(dependency) : null;
        if (exportOrRequire) {
            return exportOrRequire;
        }
        const amdModule = await this.resolveAmdDependency(dependency);
        this.dependencyCache.set(dependency, amdModule);
        return amdModule;
    }

    private resolveAmdDependency = async (dependency: string) => {
        const exportModule = {};
        const requireModule = {};
        const exportOrRquireModuleResolver = (dependency: string) => {
            if (dependency == "exports") {
                return exportModule;
            }
            else if (dependency == "require") {
                return requireModule;
            }
        }

        moduleRequirements = null;
        const imported = await import(`${baseUrl}react_app${dependency}.js?version=${versionForCacheBusting}`);
        if (moduleRequirements) {
            const moduleRequirementsCopy = { ...moduleRequirements };
            moduleRequirements = null;
            //Wenn moduleRequirements gesetzt ist, bedeutet es, dass es dich um ein AMD-Modul handelt. Es m�ssen die ben�tigten Module aufgel�st und danach muss der callback zum initialisieren aufgerufen werden.
            //Die Exports des AMD Moduls landen in dem "exports" Objekt.
            //Wenn der Parameter nicht gesetzt ist, bedeutet es, dass es sich um ein JS-Datei ohne AMD Modul handelt. Das Kann bei innosoft.custom.js der Fall sein, wenn die nur globale Objekt wie axios oder JQuery usw. verwendet.
            const newBasePath = this.getDependencyPathFromName(dependency);
            const resolvedDependencies = await this.resolveDependencies(newBasePath, moduleRequirementsCopy.requiredDependencies, exportOrRquireModuleResolver);
            moduleRequirementsCopy.callback(...resolvedDependencies);
            return exportModule;
        }
    }
}


let moduleRequirements: RequiredJob;
export function define(modules: string[], callback?: (...args: any[]) => void) {
    moduleRequirements = { requiredDependencies: modules, callback: callback }
}

const requireProcessor = new RequireProcessor();
export const requireBase = function (basePath, requiredDependencies, callback): void {
    requireProcessor.require(basePath, requiredDependencies, callback);
}
export const require = function (requiredDependencies, callback): void {
    requireProcessor.require("", requiredDependencies, callback);
}

let baseUrl = "";
let versionForCacheBusting = "";
export const setBaseUrlAndVersion = function (newBaseUrl: string, version: string) {
    baseUrl = newBaseUrl;
    versionForCacheBusting = version;
}